export default "__VITE_ASSET__DfQxIoSO__"